import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Form as ReduxForm, Field } from 'redux-form';
import { Grid, Button } from '@material-ui/core';
import { TextFieldFormControl } from '%app/js/common/components/material/TextField';
import Translator from '%app/js/common/services/translator';

const Form = (props) => {
    const {
        handleSubmit,
        pristine,
        submitting,
        classes: { input, btnGrid },
    } = props;

    return (
        <ReduxForm onSubmit={handleSubmit}>
            <Grid alignItems="center" alignContent="center" container>
                <Grid xs={12} sm={8} item>
                    <Field
                        name="token"
                        type="text"
                        label={Translator.trans('evp_ticket_frontend.checkout.discount.discount_code')}
                        placeholder={Translator.trans('evp_ticket_frontend.checkout.discount.discount_code')}
                        className={input}
                        component={TextFieldFormControl}
                        fullWidth
                    />
                </Grid>
                <Grid xs={12} sm={4} className={btnGrid} item>
                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={submitting || pristine}
                    >
                        {Translator.trans('evp_ticket_frontend.checkout.discount.apply')}
                    </Button>
                </Grid>
            </Grid>
        </ReduxForm>
    );
};

Form.propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    classes: PropTypes.shape({
        input: PropTypes.string.isRequired,
        btnGrid: PropTypes.string.isRequired,
    }).isRequired,
};

export default memo(Form);
